// Auto generated file, do not manually modify!
// com.hotpads.leasing.client.enums.LeaseStatus

export enum LeaseStatus {
  ACTIVE = 'active',
  COMPLETE_DRAFT = 'complete_draft',
  COUNTERSIGNING = 'countersigning',
  EXPIRED = 'expired',
  INCOMPLETE_DRAFT = 'incomplete_draft',
  SENT_COMPLETE_DRAFT = 'sent_complete_draft',
  SENT_FOR_OFFLINE_SIGNING = 'sent_for_offline_signing',
  SENT_FOR_ONLINE_SIGNING = 'sent_for_online_signing',
  SENT_INCOMPLETE_DRAFT = 'sent_incomplete_draft',
  SIGNED_BY_TENANT = 'signed_by_tenant',
  SIGNING_CANCELLED = 'signing_cancelled',
  SIGNING_COMPLETE = 'signing_complete',
  TERMINATED = 'terminated',
}

export const LeaseStatus_values = [
  LeaseStatus.ACTIVE,
  LeaseStatus.COMPLETE_DRAFT,
  LeaseStatus.COUNTERSIGNING,
  LeaseStatus.EXPIRED,
  LeaseStatus.INCOMPLETE_DRAFT,
  LeaseStatus.SENT_COMPLETE_DRAFT,
  LeaseStatus.SENT_FOR_OFFLINE_SIGNING,
  LeaseStatus.SENT_FOR_ONLINE_SIGNING,
  LeaseStatus.SENT_INCOMPLETE_DRAFT,
  LeaseStatus.SIGNED_BY_TENANT,
  LeaseStatus.SIGNING_CANCELLED,
  LeaseStatus.SIGNING_COMPLETE,
  LeaseStatus.TERMINATED,
] as const;
